export const itgProcess = state => state.itgProcess;
